<ion-content>
  <ion-grid class="constrained-content">
    <ion-row>
      <ion-col size-md="4" size="12" class="settings-title-section">
        <h1>
          <ion-icon name="sparkles-outline"></ion-icon>Artificial Intelligence
        </h1>
        <p class="subtitle">
          Leverage AI-generated support to save time and provide a better
          customer experience.
        </p>
      </ion-col>
      <ion-col size="12" size-md="8">
        <ion-row>
          <ion-col size="12">
            <ion-card class="outline-card flex-space-between">
              <ion-card-title class="card-title">
                <div class="option-description">
                  <h3>LLM</h3>
                  <div class="subtitle">
                    The underlying AI that powers responses.
                  </div>
                </div>
              </ion-card-title>
              <div class="flexed-align-center">
                <div class="code">
                  {{ getLlmName() }} –
                  {{ tenant.llmConfig?.model || "default" }}
                </div>
                <ion-button
                  fill="clear"
                  ngxTippy
                  data-tippy-content="Contact us to change model"
                  (click)="requestAccess('Custom AI Model')"
                >
                  <ion-icon
                    name="lock-closed-outline"
                    style="margin: 0; font-size: 0.75rem"
                  ></ion-icon>
                  Change
                </ion-button>
              </div>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title flex-space-between">
                <div class="option-description">
                  <h3>Automatically Set Ticket Type</h3>
                  <div class="subtitle">
                    Automatically set the ticket type based on the conversation
                    content. Note: This will also control whether or not ticket
                    form fields are prefilled.
                  </div>
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    [(ngModel)]="aiFeatures.autoTicketType"
                    (click)="onChange()"
                  />
                  <span class="slider"></span>
                </label>
              </ion-card-title>
              <ion-list [hidden]="!aiFeatures.autoTicketType">
                <ion-item>
                  <ion-button fill="clear" (click)="manageTicketTypes()">
                    <ion-icon
                      name="pricetags-outline"
                      class="padded-icon"
                    ></ion-icon>
                    Manage ticket types
                  </ion-button>
                </ion-item>
                <ion-item>
                  <ion-button fill="clear" (click)="viewTicketTypeAnalytics()">
                    <ion-icon
                      name="analytics-outline"
                      class="padded-icon"
                    ></ion-icon>
                    View ticket type analytics
                  </ion-button>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title flex-space-between">
                <div class="option-description">
                  <h3>Automatic Tagging</h3>
                  <div class="subtitle">
                    Apply tags to conversations based on message content. You
                    can still manually add and remove.
                  </div>
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    [(ngModel)]="aiFeatures.autoTagging"
                    (click)="onChange()"
                  />
                  <span class="slider"></span>
                </label>
              </ion-card-title>
              <ion-list [hidden]="!aiFeatures.autoTagging">
                <ion-item [hidden]="!aiFeatures.autoTagging">
                  <ion-label position="stacked"
                    >Maximum number of auto-generated tags</ion-label
                  >
                  <ion-input
                    type="number"
                    [(ngModel)]="aiFeatures.maxAutoTags"
                    (ionBlur)="onChange()"
                    min="1"
                    max="10"
                  ></ion-input>
                </ion-item>
                <ion-item>
                  <ion-button fill="clear" (click)="manageTags()">
                    <ion-icon
                      name="pricetags-outline"
                      class="padded-icon"
                    ></ion-icon>
                    Manage tags
                  </ion-button>
                </ion-item>
                <ion-item>
                  <ion-button fill="clear" (click)="viewTagAnalytics()">
                    <ion-icon
                      name="analytics-outline"
                      class="padded-icon"
                    ></ion-icon>
                    View tag analytics
                  </ion-button>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title flex-space-between">
                <div class="option-description">
                  <h3>AI-Generated Responses</h3>
                  <div class="subtitle">
                    Allow the AI to respond directly or recommend responses to
                    support reps.
                  </div>
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    [(ngModel)]="aiFeatures.suggestResponses"
                    (click)="onChange()"
                  />
                  <span class="slider"></span>
                </label>
              </ion-card-title>
              <ion-list>
                <ion-item>
                  <ion-button fill="clear" (click)="manageDocs()">
                    <ion-icon
                      name="book-outline"
                      class="padded-icon"
                    ></ion-icon>
                    Manage knowledge base articles
                  </ion-button>
                </ion-item>
                <ion-item>
                  <ion-button fill="clear" (click)="manageAutoresponder()">
                    <ion-icon
                      name="chatbubbles-outline"
                      class="padded-icon"
                    ></ion-icon>
                    Auto-responder settings
                  </ion-button>
                </ion-item>
                <ion-item>
                  <ion-button fill="clear" (click)="viewAIAnalytics()">
                    <ion-icon
                      name="analytics-outline"
                      class="padded-icon"
                    ></ion-icon>
                    View AI analytics
                  </ion-button>
                </ion-item>
              </ion-list>
              <ion-list [hidden]="!aiFeatures.suggestResponses">
                <ion-item>
                  <ion-label position="stacked"> Custom Prompt </ion-label>
                  <ion-textarea
                    [(ngModel)]="interactiveModeCustomPrompt"
                    (ionBlur)="onChange()"
                    placeholder="Enter a custom prompt to influence AI behavior"
                    [rows]="10"
                  ></ion-textarea>
                </ion-item>
                <ion-item>
                  <ion-label position="stacked"> Temperature </ion-label>
                  <ion-range
                    aria-label="Temperature"
                    [min]="0"
                    [max]="100"
                    [(ngModel)]="aiFeatures.temperature"
                    [pin]="true"
                    [ticks]="true"
                    [snaps]="true"
                    (ionKnobMoveEnd)="onChange()"
                  >
                    <ion-label slot="start">0 - More Consistent</ion-label>
                    <ion-label slot="end">100 - More Random</ion-label>
                  </ion-range>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title flex-space-between">
                <div class="option-description">
                  <h3>Static AI Response Prefix</h3>
                  <div class="subtitle">
                    Configure a prefix message displayed before AI responses.
                    Optionally, include an additional message for outside
                    working hours.
                  </div>
                </div>
                <div></div>
              </ion-card-title>
              <ion-list>
                <ion-item>
                  <ion-label position="stacked">Prefix Message</ion-label>
                  <ion-textarea
                    [(ngModel)]="aiFeatures.agentStaticPrefix"
                    (ionBlur)="onChange()"
                    placeholder="Enter static prefix message"
                    rows="3"
                  ></ion-textarea>
                </ion-item>
                <ion-item>
                  <ion-label position="stacked"
                    >Outside Working Hours Additional Message
                    (Optional)</ion-label
                  >
                  <ion-textarea
                    [(ngModel)]="
                      aiFeatures.agentStaticPrefixOutsideWorkingHours
                    "
                    (ionBlur)="onChange()"
                    placeholder="Enter additional message for outside working hours"
                    rows="3"
                  ></ion-textarea>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title flex-space-between">
                <div class="option-description">
                  <h3>Generate Titles</h3>
                  <div class="subtitle">
                    Let Unthread AI generate conversation titles based on the
                    incoming message.
                  </div>
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    [(ngModel)]="aiFeatures.autoTitle"
                    (click)="onChange()"
                  />
                  <span class="slider"></span>
                </label>
              </ion-card-title>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title flex-space-between">
                <div class="option-description">
                  <h3>Auto Prioritize</h3>
                  <div class="subtitle">
                    Let Unthread AI automatically prioritize conversations based
                    on urgency and sentiment.
                  </div>
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    [(ngModel)]="aiFeatures.autoPrioritize"
                    (click)="onChange()"
                  />
                  <span class="slider"></span>
                </label>
              </ion-card-title>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title flex-space-between">
                <div class="option-description">
                  <h3>Summarize Conversations</h3>
                  <div class="subtitle">
                    After a conversation is closed, generate a human-friendly
                    summary.
                  </div>
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    [(ngModel)]="aiFeatures.autoSummarize"
                    (click)="onChange()"
                  />
                  <span class="slider"></span>
                </label>
              </ion-card-title>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title flex-space-between">
                <div class="option-description">
                  <h3>Surface Similar Conversations</h3>
                  <div class="subtitle">
                    Show a list of related conversations that may be relevant to
                    a new conversation.
                  </div>
                </div>
                <ion-button color="success" fill="clear" [disabled]="true">
                  <ion-icon name="checkmark" class="padded-icon"></ion-icon
                  >Enabled
                </ion-button>
              </ion-card-title>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title flex-space-between">
                <div class="option-description">
                  <h3>Customer Sentiment</h3>
                  <div class="subtitle">
                    Measure a score of customer sentiment.
                  </div>
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    [(ngModel)]="aiFeatures.customerSentiment"
                    (click)="onChange()"
                  />
                  <span class="slider"></span>
                </label>
              </ion-card-title>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title flex-space-between">
                <div class="option-description">
                  <h3>Email Thread Parsing</h3>
                  <div class="subtitle">
                    Parse forwarded email threads and break them into their
                    constituent messages.
                  </div>
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    [(ngModel)]="aiFeatures.emailThreadAnalysis"
                    (click)="onChange()"
                  />
                  <span class="slider"></span>
                </label>
              </ion-card-title>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title flex-space-between">
                <div class="option-description">
                  <h3>Silent Autoresponder Analysis</h3>
                  <div class="subtitle">
                    Quietly generate and collect AI response data in the
                    background when the autoresponder is turned off. Helps build
                    confidence in your AI before enabling it for real
                    interactions. Note: This may have cost and performance
                    implications. Use with caution.
                  </div>
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    [(ngModel)]="aiFeatures.passiveAutoresponseAnalytics"
                    (click)="onChange()"
                  />
                  <span class="slider"></span>
                </label>
              </ion-card-title>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title flex-space-between">
                <div class="option-description">
                  <h3>AI Generated Content Language</h3>
                  <div class="subtitle">
                    Set the language for AI generated titles and summaries.
                  </div>
                </div>
              </ion-card-title>
              <ion-list>
                <ion-item>
                  <ion-label position="stacked">Language</ion-label>
                  <ion-select
                    [(ngModel)]="aiFeatures.generatedContentLanguage"
                    (ionChange)="onChange()"
                    interface="popover"
                  >
                    <ion-select-option
                      *ngFor="let lang of availableLanguages"
                      [value]="lang.code"
                    >
                      {{ lang.name }}
                    </ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-toolbar class="constrained-content">
    <ion-button color="success" (click)="save()" class="save-button"
      >Save changes
    </ion-button>
  </ion-toolbar>
</ion-footer>
